import React from "react";

const AuthLayout = ({ children, showSidebar = false, currentStep = 0 }) => {
  const steps = [
    {
      icon: "👤",
      title: "Your Details",
      description: "Please provide your name and email.",
    },
    {
      icon: "🏢",
      title: "Company Details",
      description: "Please provide your company name and size.",
    },
    {
      icon: "👥",
      title: "Invite your team",
      description: "Start collaborating with your team.",
    },
    {
      icon: "📎",
      title: "Upload assets",
      description: "Start collaborating with your team.",
    },
  ];

  return (
    <div className="min-h-screen bg-[#0C0E12] flex">
      {showSidebar && (
        <div className="w-96 bg-dark-secondary p-8 border-r border-gray-800">
          <div className="mb-12">
            <h2 className="text-2xl font-bold text-gray-400">Logo</h2>
          </div>
          <div className="space-y-8">
            {steps.map((step, index) => (
              <div
                key={index}
                className={`flex gap-4 ${
                  currentStep === index ? "text-white" : "text-gray-500"
                }`}
              >
                <div className="text-2xl">{step.icon}</div>
                <div>
                  <h3 className="font-semibold">{step.title}</h3>
                  <p className="text-sm">{step.description}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="absolute bottom-8 left-8">
            <p className="text-gray-500 text-sm">© Gradeateam 2025</p>
            <p className="text-gray-500 text-sm">help@gradateam.co.uk</p>
          </div>
        </div>
      )}
      <div className="w-full">{children}</div>
    </div>
  );
};

export default AuthLayout;
